import { styled } from '@mui/material';
import type { ReactNode } from 'react';
import React from 'react';

import Line2 from '../../assets/images/line_doodle_2.svg?react';
import Line4 from '../../assets/images/line_doodle_4.svg?react';

const Root = styled('span')({
  position: 'relative',
  whiteSpace: 'nowrap',
  isolation: 'isolate',
});

const StyledLine = styled('div')({
  '--color': '#FFC14A',
  position: 'absolute',
  right: 0,
  bottom: 3,
  transform: 'translateY(100%)',
  width: '100%',
  height: 'auto',
  '& path': {
    stroke: 'var(--color)',
  },
  zIndex: -1,
});

export type UnderlinedTextProps = {
  children?: ReactNode;
  variant?: '2' | '4';
  color?: string;
  distance?: string;
};

const mapping = {
  '2': Line2,
  '4': Line4,
};

export const UnderlinedText: React.FC<UnderlinedTextProps> = ({
  variant = '2',
  distance,
  children,
  color,
}) => {
  return (
    <Root>
      {children}
      <StyledLine
        style={{
          ['--color' as string]: color,
          bottom: distance,
        }}
        as={mapping[variant]}
      />
    </Root>
  );
};
